// extracted by mini-css-extract-plugin
export default {"section":"PlansSection_section__mI07s","sectionHeader":"PlansSection_sectionHeader__CLU6v","plans":"PlansSection_plans__0Fwaj","sectionBottom":"PlansSection_sectionBottom__k8R7D"};